// extracted by mini-css-extract-plugin
export default {"container":"_1j7Qb","title":"_1a655","widgetContent":"Y6kvo","spinner":"_1Thj2","item":"Q-AmO"};